import React from "react";
import HeroSection from "./DroneManufacturing/HeroSection";
import MagicBento from "./DroneManufacturing/MagicBento";
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const DroneManufacturingMain = () => {
  return (
    <div>
      <HeroSection />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </div>
  );
};

export default DroneManufacturingMain;
